
import React from "react";
import { useTranslations } from "use-intl";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

interface BulkApprovalsProps {
  selectedInvoices: string[];
  handleBulkApprove: () => void;
  handleApproveAll?: () => void;
  showApproveAll?: boolean;
}

const BulkApprovals: React.FC<BulkApprovalsProps> = ({
  selectedInvoices,
  handleBulkApprove,
  handleApproveAll,
  showApproveAll = false,
}) => {
  const t = useTranslations("consultantApprovals.bulk");
  return (
    <div className="flex justify-between items-center mb-4">
      <div>
        {selectedInvoices.length > 0 && (
          <span className="font-medium">{t("selected", { count: String(selectedInvoices.length) })}</span>
        )}
      </div>
      <div className="flex gap-2">
        {selectedInvoices.length > 0 && (
          <Button 
            variant="default" 
            size="sm"
            className="flex items-center gap-2" 
            onClick={handleBulkApprove}
          >
            <CheckCircle className="h-4 w-4" />
            {t("approveSelected")}
          </Button>
        )}
        {showApproveAll && handleApproveAll && (
          <Button 
            variant="outline" 
            size="sm"
            className="flex items-center gap-2" 
            onClick={handleApproveAll}
          >
            <CheckCircle className="h-4 w-4" />
            {t("approveAll")}
          </Button>
        )}
      </div>
    </div>
  );
};

export default BulkApprovals;
